import React, { useState, useMemo } from 'react';
import './App.css';

const items = [
  { name: 'Classic Coxinha', price: 6.5 },
  { name: 'Catupiry Coxinha', price: 6.5 },
  { name: 'Brigadeiro', price: 1.8 },
  { name: 'Mini Carrot Cake', price: 5.5 },
];

const CANADIAN_HOLIDAYS = [
  '2025-07-01', '2025-09-01', '2025-10-13', '2025-12-25', '2025-12-26', '2026-01-01',
];

function getOttawaNow() {
  try {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
  } catch {
    return new Date();
  }
}

function getTimeOptions() {
  const min = 16, max = 19;
  const options = [];
  for (let h = min; h <= max; h++) {
    for (let m = 0; m < 60; m += 15) {
      if (h === max && m > 0) break;
      const hour = h.toString().padStart(2, '0');
      const minStr = m.toString().padStart(2, '0');
      options.push(`${hour}:${minStr}`);
    }
  }
  return options;
}

const OrderNowPage = () => {
  const [quantities, setQuantities] = useState([0, 0, 0, 0]);
  const [orderType, setOrderType] = useState('pickup');
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [selectedTime, setSelectedTime] = useState('16:00');
  const [showSummary, setShowSummary] = useState(false);
  const [showOrderSent, setShowOrderSent] = useState(false);
  const [orderSentInfo, setOrderSentInfo] = useState(null);
  const [showOrderLoading, setShowOrderLoading] = useState(false);
  const todayStr = new Date().toISOString().split('T')[0];

  const handleChange = (idx, delta) => {
    setQuantities(qs => {
      const next = [...qs];
      next[idx] = Math.max(0, Math.min(99, next[idx] + delta));
      return next;
    });
  };

  const allZero = quantities.every(q => q === 0);
  const canSend = !allZero && orderType !== null;
  const subtotal = quantities.reduce((sum, qty, idx) => sum + qty * items[idx].price, 0);

  const [form, setForm] = useState({ name: '', email: '', phone: '', address: '' });
  const [formErrors, setFormErrors] = useState({});

  function validateForm() {
    const errors = {};
    if (!form.name.trim()) errors.name = 'Name is required.';
    if (!form.email.trim()) errors.email = 'Email is required.';
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) errors.email = 'Invalid email address.';
    if (!form.phone.trim()) errors.phone = 'Phone is required.';
    else if (!/^\d{10}$|^\d{3} \d{7}$|^\d{3} \d{3}-\d{4}$|^\d{3} \d{3} \d{4}$/.test(form.phone)) {
      errors.phone = 'Format: dddddddddd, ddd ddddddd, ddd ddd-dddd, or ddd ddd dddd';
    }
    if (!form.address.trim()) errors.address = 'Address is required.';
    return errors;
  }

  function handleFormChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  }

  function handleSendOrder(e) {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      setShowOrderLoading(true);
      const payload = {
        order: orderState,
        contact: form,
      };
      fetch('http://localhost:5000/api/send-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(data => {
          setShowOrderLoading(false);
          if (data.success) {
            setOrderSentInfo({
              orderType: orderState.orderType,
              date: orderState.selectedDate,
              time: orderState.selectedTime,
              subtotal: orderState.subtotal,
              items: orderState.items,
            });
            setShowOrderSent(true);
            setShowSummary(false);
            setQuantities([0, 0, 0, 0]);
            setForm({ name: '', email: '', phone: '', address: '' });
          } else {
            alert('Failed to send order: ' + (data.error || 'Unknown error'));
          }
        })
        .catch(err => {
          setShowOrderLoading(false);
          alert('Failed to send order: ' + err.message);
        });
    }
  }

  function getAllowedDates() {
    const allowed = [];
    const today = getOttawaNow();
    const nowHour = today.getHours();
    const nowMinute = today.getMinutes();
    const after1pm = (nowHour > 13) || (nowHour === 13 && nowMinute > 0);
    for (let i = 0; i < 90; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      const day = d.getDay();
      const dateStr = d.toISOString().split('T')[0];
      if (i === 0 && after1pm) continue;
      if (
        (orderType === 'pickup' && day >= 2 && day <= 6 && !CANADIAN_HOLIDAYS.includes(dateStr)) ||
        (orderType === 'delivery' && day === 6 && !CANADIAN_HOLIDAYS.includes(dateStr))
      ) {
        allowed.push(dateStr);
      }
    }
    return allowed;
  }
  function isDateAllowed(dateStr) {
    return getAllowedDates().includes(dateStr);
  }
  React.useEffect(() => {
    if (!isDateAllowed(selectedDate)) {
      const allowed = getAllowedDates();
      setSelectedDate(allowed[0] || todayStr);
    }
  }, [orderType, selectedDate]);

  const orderState = useMemo(() => {
    return {
      orderType,
      selectedDate,
      selectedTime,
      items: items
        .map((item, idx) => ({ ...item, quantity: quantities[idx] }))
        .filter(item => item.quantity > 0),
      subtotal,
    };
  }, [orderType, selectedDate, selectedTime, quantities, subtotal]);

  const timeOptions = getTimeOptions();

  return (
    <div className="order-now-page">
      <div className="order-now-container">
        <img
          className="order-now-top-img"
          src="/images/order-now-img1.png"
          alt="Order Now"
        />
        <h1>{showOrderSent ? 'Order Sent' : 'Order Now'}</h1>
        {showOrderSent && (
          <div className="order-sent-summary">
            <div><strong>Items:</strong></div>
            <ul>
              {orderSentInfo.items.map(item => (
                <li key={item.name}>{item.name} x{item.quantity} (${item.price.toFixed(2)} each)</li>
              ))}
            </ul>
            <div><strong>Subtotal:</strong> CAD$ {orderSentInfo.subtotal.toFixed(2)}</div>
            <div><strong>Order type:</strong> {orderSentInfo.orderType}</div>
            <div><strong>Date/Time:</strong> {orderSentInfo.date} {orderSentInfo.time}</div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 18 }}>
              <button className="close-modal-btn" onClick={() => setShowOrderSent(false)}>Close</button>
            </div>
          </div>
        )}
        {showOrderLoading && (
          <div className="order-loading-animation"><div className="spinner"></div> Sending order...</div>
        )}
        {!showOrderSent && !showOrderLoading && (
          <>
            {showSummary ? (
              <>
                <div className="order-summary-content">
                  <div className="order-summary-title">Summary</div>
                  <div className="order-summary-section">
                    <div className="order-summary-label">Order:</div>
                    <ul className="order-summary-list">
                      {items.map((item, idx) => (
                        quantities[idx] > 0 && (
                          <li key={item.name} className="order-summary-item">
                            <span>{item.name}</span>
                            <span>x{quantities[idx]}</span>
                          </li>
                        )
                      ))}
                    </ul>
                  </div>
                  <div className="order-summary-section">
                    <span className="order-summary-label">Subtotal:</span>
                    <span className="order-summary-value" style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 400 }}>
                      CAD$ {subtotal.toFixed(2)}
                    </span>
                  </div>
                  <div className="order-summary-section">
                    <span className="order-summary-label">Date:</span>
                    <span className="order-summary-value" style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 400 }}>
                      {selectedDate} {selectedTime}
                    </span>
                  </div>
                </div>
                <div className="contact-details-box">
                  <div className="contact-details-title">CONTACT</div>
                  <form className="order-form" autoComplete="off" onSubmit={handleSendOrder} id="order-form">
                    <div className="form-group">
                      <label htmlFor="order-name">Name</label>
                      <input id="order-name" name="name" type="text" className="order-input" value={form.name} onChange={handleFormChange} required />
                      {formErrors.name && <div className="form-error">{formErrors.name}</div>}
                    </div>
                    <div className="form-group">
                      <label htmlFor="order-email">Email</label>
                      <input id="order-email" name="email" type="email" className="order-input" value={form.email} onChange={handleFormChange} required />
                      {formErrors.email && <div className="form-error">{formErrors.email}</div>}
                    </div>
                    <div className="form-group">
                      <label htmlFor="order-phone">Phone</label>
                      <input id="order-phone" name="phone" type="text" className="order-input" value={form.phone} onChange={handleFormChange} required placeholder="123 456-7890" />
                      {formErrors.phone && <div className="form-error">{formErrors.phone}</div>}
                    </div>
                    <div className="form-group">
                      <label htmlFor="order-address">Address</label>
                      <input id="order-address" name="address" type="text" className="order-input" value={form.address} onChange={handleFormChange} required />
                      {formErrors.address && <div className="form-error">{formErrors.address}</div>}
                    </div>
                  </form>
                </div>
                <div className="summary-actions" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
                  <button className="back-btn" onClick={() => setShowSummary(false)}>Back</button>
                  <button className="send-order-btn" type="submit" form="order-form">Send Order</button>
                </div>
              </>
            ) : (
              <>
                <div className="info-box">
                  <div style={{ fontWeight: 700 }}>Same-day Orders</div>
                  <div>
                    To order for today please order before 1pm.<br/>
                    Orders after 1pm will be considered for the next available date. Thank you!
                  </div>
                </div>
                <div className="order-type-toggle">
                  <button
                    className={`toggle-btn${orderType === 'pickup' ? ' selected' : ''}`}
                    onClick={() => setOrderType('pickup')}
                    type="button"
                  >
                    Pickup
                  </button>
                  <button
                    className={`toggle-btn${orderType === 'delivery' ? ' selected' : ''}`}
                    onClick={() => setOrderType('delivery')}
                    type="button"
                  >
                    Delivery
                  </button>
                </div>
                {orderType === 'delivery' && (
                  <div className={orderType === 'delivery' ? 'delivery-info-box active' : 'delivery-info-box'}>
                    delivery rate will be calculate based on the address provided.
                  </div>
                )}
                <div className="order-items-box">
                  <div className="order-items-title">order</div>
                  <ul className="order-list">
                    {items.map((item, idx) => (
                      <li key={item.name} className="order-list-item">
                        <div className="item-main-row">
                          <div className="item-info-block">
                            <span className="item-name">{item.name}</span>
                            <span className="item-price">${item.price.toFixed(2)}</span>
                          </div>
                          <span className="item-counter">
                            <button
                              className="counter-btn"
                              onClick={() => handleChange(idx, -1)}
                              disabled={quantities[idx] === 0}
                              aria-label={`Decrease ${item.name}`}
                            >-</button>
                            <span className="counter-value">{quantities[idx]}</span>
                            <button
                              className="counter-btn"
                              onClick={() => handleChange(idx, 1)}
                              disabled={quantities[idx] === 99}
                              aria-label={`Increase ${item.name}`}
                            >+</button>
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div className="subtotal-row">
                    <span className="subtotal-label">Subtotal</span>
                    <span className="subtotal-value">
                      CAD$ {subtotal.toFixed(2)}
                    </span>
                  </div>
                </div>
                <div className="date-box">
                  <div className="date-box-title">DATE</div>
                  <div className="info-box" style={{ marginBottom: 14, marginTop: -4 }}>
                    <span style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 700 }}>
                      Pickup available
                    </span> from Tuesday to Saturday from 4pm to 7pm<br/>
                    <span style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontWeight: 700 }}>
                      Delivery available
                    </span> on Saturdays from 4pm to 7pm
                  </div>
                  <div className="date-time-row">
                    <input
                      type="date"
                      className="date-picker-input"
                      value={selectedDate}
                      min={todayStr}
                      onChange={e => setSelectedDate(e.target.value)}
                      aria-label="Select order date"
                      list="allowed-dates"
                    />
                    <datalist id="allowed-dates">
                      {getAllowedDates().map(date => (
                        <option key={date} value={date} />
                      ))}
                    </datalist>
                    <select
                      className="time-picker-input"
                      value={selectedTime}
                      onChange={e => setSelectedTime(e.target.value)}
                      aria-label="Select order time"
                    >
                      {timeOptions.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  className="send-order-btn"
                  disabled={!canSend}
                  type="button"
                  onClick={() => setShowSummary(true)}
                >
                  Next
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OrderNowPage;
